import type { ComponentProps, FC, PropsWithChildren } from 'react';
import SocialMediaIcons from './social-media-icons';
import FooterLogo from './footer-logo';
import AppStoreBadges from './app-store-badges';
import { twJoin, twMerge } from 'tailwind-merge';
import { Locale } from '@tuic/i18n';
import { I18NFromComponent } from '../../../utils';
import AppStoreRating from './app-store-rating';
type Props = {
  socialMedia?: ComponentProps<typeof SocialMediaIcons>;
  appStoreBadges?: ComponentProps<typeof AppStoreBadges>;
  locale?: Locale;
  i18n?: I18NFromComponent<typeof AppStoreRating>;
};
type TMetaNavigation = FC<Props> & {
  Title: FC<PropsWithChildren<{
    className?: string;
  }>>;
};
const Title: TMetaNavigation['Title'] = ({
  className,
  children
}) => {
  return <h3 className={twMerge(twJoin('mb-[0.5em] text-center text-[1.25rem] font-semibold leading-[1.875rem] lg:text-left', className))} data-sentry-component="Title" data-sentry-source-file="meta-navigation.tsx">
      {children}
    </h3>;
};

/**
 * Renders the meta navigation of the footer.
 */
const MetaNavigation: TMetaNavigation = ({
  appStoreBadges,
  socialMedia,
  locale,
  i18n
}) => {
  return <div className="flex flex-col px-[42.5px] py-0 lg:h-full lg:items-start lg:justify-between lg:p-0 [&>div]:mb-10" data-sentry-component="MetaNavigation" data-sentry-source-file="meta-navigation.tsx">
      <div className="flex lg:hidden mr-[-1.875rem]">
        <FooterLogo locale={locale} data-sentry-element="FooterLogo" data-sentry-source-file="meta-navigation.tsx" />
      </div>
      <div>
        <SocialMediaIcons {...socialMedia} data-sentry-element="SocialMediaIcons" data-sentry-source-file="meta-navigation.tsx" />
      </div>
      <div>
        <AppStoreBadges {...appStoreBadges} i18n={i18n} data-sentry-element="AppStoreBadges" data-sentry-source-file="meta-navigation.tsx" />
      </div>
      <div className="hidden lg:flex max-w-[300px]">
        <FooterLogo locale={locale} data-sentry-element="FooterLogo" data-sentry-source-file="meta-navigation.tsx" />
      </div>
    </div>;
};
MetaNavigation.Title = Title;
export default MetaNavigation;